import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {
	VueJsonp
} from 'vue-jsonp'

import App from './App.vue'
import router from './router'
Vue.config.productionTip = false
Vue.use(VueJsonp)
Vue.use(ElementUI);
new Vue({
	router,
	render: h => h(App),
}).$mount('#app')